const Ruler = {
  order: 0,
  run($$) {
    $$.$.on("seats:rendered", () => $$.$arena.find(".seats-container > .h-ruler").draggable({
      containment: "parent",
      axis: "x",
      grid: [1, 1],
      snap: "[data-type]",
    }));
  },
};

window.SectionRuler = Ruler;

export default Ruler;
